import React from 'react';
import AttachmentsComponent from '../Elements/AttachmentsComponent';
import ClientFeesComponent from '../Elements/ClientFeesComponent';
import TabbedPage from '../Elements/TabbedPage';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import OperationsProjectService from '../Services/OperationsProjectService';
import Comments from '../Elements/Comments';
import ProjectSurveyAdmin from '../Contents/Operations/Projects/ProjectSurveyAdmin';
import AllAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/AllAssignmentsList';
import ExcludedAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/ExcludedAssignmentsList';
import UninvoiceableAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/UninvoiceableAssignmentsList';
import FinalizedAssignmentsList from '../Contents/Operations/Projects/Assignments/AssignmentLists/FinalizedAssignmentsList';
import dateTimeHelper from '../Helpers/datetimeHelper';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';

class ProjectItem {
  constructor(item) {
    if (item === undefined) {
      this.CfId = '';
      this.CfCcid = '';
      this.CfCcname = '';
      this.CfCcSassieId = '';
      this.ClientDaysToPayCode = '';
      this.ClientInvoiceInterestRate = '';
      this.CfOpportunityId = '';
      this.CfOpportunityName = '';
      this.CfOpportunityDisplayName = '';
      this.CfOpportunityStatusCode = '';
      this.CfOpportunityActualStartOn = '';
      this.CfOpportunityActualEndOn = '';
      this.CfServiceId = '';
      this.CfServiceTypeCode = '';
      this.CfServiceName = '';
      this.CfLdvid = '';
      this.CfLdvname = '';
      this.CfLdpid = '';
      this.CfLdpname = '';
      this.CfLstid = '';
      this.CfLstname = '';
      this.CfClientFee = '';
      this.CfReimbursement = '';
      this.CfMisc = '';
      this.CfTravel = '';
      this.CfGaming = '';
      this.CfVat = '';
      this.CfName = '';
      this.CfDisplayName = '';
      this.CfSassieId = '';
      this.CfCoid = '';
      this.CfConame = '';
      this.CfUsid = '';
      this.CfUsname = '';
      this.CfProjectManagerId = '';
      this.CfProjectManagerName = '';
      this.CfMod = '';
      this.CfReimbType = '';
      this.CfReimbTypeText = '';
      this.CfComments = '';
      this.CfOrder = '';
      this.CfStartDate = new Date();
      this.CfEndDate = dateTimeHelper.addDaysToDate(new Date(), 1);
      this.CfRcyid = '';
      this.CfRcycode = '';
      this.CfRcysymbol = '';
      this.CfRcyrate = '';
      this.CfRcyrateinv = '';
      this.CreatedBy = '';
      this.CreatedByName = '';
      this.CreatedOn = '';
      this.ShopCountInCycle = '';
      this.Editor1Payment = '';
      this.Editor2Payment = '';
      this.Editor1PaymentCurrency = '';
      this.Editor2PaymentCurrency = '';
      this.Editor1PaymentCurrencyCode = '';
      this.Editor2PaymentCurrencyCode = '';
      this.MaximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate = '';
      this.CfDeactivated = '';
      this.IsInvoiced = '';
      return;
    }
    this.CfId = item.cfId;
    this.CfCcid = item.cfCcid;
    this.CfCcname = item.cfCcname;
    this.CfCcSassieId = item.cfCcSassieId;
    this.ClientDaysToPayCode = item.clientDaysToPayCode;
    this.ClientInvoiceInterestRate = item.clientInvoiceInterestRate;
    this.CfOpportunityId = item.cfOpportunityId;
    this.CfOpportunityName = item.cfOpportunityName;
    this.CfOpportunityDisplayName = item.cfOpportunityDisplayName;
    this.CfOpportunityStatusCode = item.cfOpportunityStatusCode;
    this.CfOpportunityActualStartOn = item.cfOpportunityActualStartOn;
    this.CfOpportunityActualEndOn = item.cfOpportunityActualEndOn;
    this.CfServiceId = item.cfServiceId;
    this.CfServiceTypeCode = item.cfServiceTypeCode;
    this.CfServiceName = item.cfServiceName;
    this.CfLdvid = item.cfLdvid;
    this.CfLdvname = item.cfLdvname;
    this.CfLdpid = item.cfLdpid;
    this.CfLdpname = item.cfLdpname;
    this.CfLstid = item.cfLstid;
    this.CfLstname = item.cfLstname;
    this.CfClientFee = item.cfClientFee;
    this.CfReimbursement = item.cfReimbursement;
    this.CfMisc = item.cfMisc;
    this.CfTravel = item.cfTravel;
    this.CfGaming = item.cfGaming;
    this.CfVat = item.cfVat;
    this.CfName = item.cfName;
    this.CfDisplayName = item.cfDisplayName;
    this.CfSassieId = item.cfSassieId;
    this.CfCoid = item.cfCoid;
    this.CfConame = item.cfConame;
    this.CfUsid = item.cfUsid;
    this.CfUsname = item.cfUsname;
    this.CfProjectManagerId = item.cfProjectManagerId;
    this.CfProjectManagerName = item.cfProjectManagerName;
    this.CfMod = item.cfMod;
    this.CfReimbType = item.cfReimbType;
    this.CfReimbTypeText = item.cfReimbTypeText;
    this.CfComments = item.cfComments;
    this.CfOrder = item.cfOrder;
    this.CfStartDate = item.cfStartDate;
    this.CfEndDate = item.cfEndDate;
    this.CfRcyid = item.cfRcyid;
    this.CfRcycode = item.cfRcycode;
    this.CfRcysymbol = item.cfRcysymbol;
    this.CfRcyrate = item.cfRcyrate;
    this.CfRcyrateinv = item.cfRcyrateinv;
    this.CreatedBy = item.createdBy;
    this.CreatedByName = item.createdByName;
    this.CreatedOn = item.createdOn;
    this.ShopCountInCycle = item.shopCountInCycle;
    this.Editor1Payment = item.editor1Payment;
    this.Editor2Payment = item.editor2Payment;
    this.Editor1PaymentCurrency = item.editor1PaymentCurrency;
    this.Editor2PaymentCurrency = item.editor2PaymentCurrency;
    this.Editor1PaymentCurrencyCode = item.editor1PaymentCurrencyCode;
    this.Editor2PaymentCurrencyCode = item.editor2PaymentCurrencyCode;
    this.MaximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate =
      item.maximumIntervalInMonthsBetweenOpportunityEndDateAndProjectEndDate;
    this.CfDeactivated = item.cfDeactivated;
  }

  static NameOfTheIdField() {
    return 'CfId';
  }
  static nameOfTheItemDetailList(item) {
    if (item)
      return (
        <span>
          Project Details -{' '}
          <LongText
            text={`${item.CfCcname} - ${item.CfName} (${item.CfId})`}
            maxLength={40}
          />
        </span>
      );
    return 'Project Details';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Project ID',
        orderById: 'CfId',
        data: 'CfId',
        type: FieldTypesEnum.DataFieldWithDetails,
        roleKey: 'project_viewdetail',
      },
      { label: 'Client', orderById: 'CfCcname', data: 'CfCcname' },
      { label: 'Project', orderById: 'CfName', data: 'CfName' },
      { label: 'Start On', orderById: 'CfStartDate', data: 'CfStartDate' },
      { label: 'End On', orderById: 'CfEndDate', data: 'CfEndDate' },
      { label: 'Office', orderById: 'CfLdvname', data: 'CfLdvname' },
      { label: 'Service Type', orderById: 'CfLstname', data: 'CfLstname' },
      {
        label: 'Primary Project Manager',
        orderById: 'CfProjectManagerName',
        data: 'CfProjectManagerName',
        minWidth: '150px',
      },
      {
        label: ' ',
        orderById: '',
        data: ProjectItem.getActionsContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: 'fa-solid fa-edit',
            text: 'Edit',
            onClick: () => ProjectItem.editFunction(item.CfId, item),
            roleKey: 'project_edit',
          },
        ]}
      />
    );
  }

  static editFunction = (id, item, itemList) => {
    alert('Empty function');
  };

  static DateFields = ['CfStartDate', 'CfEndDate'];

  static MoneyFields = [];

  static MoneyFieldsSecondary = [];

  static BoolFields = [];

  static serviceFunctionForListTable = (item) => OperationsProjectService.GetProjectById(item.CfId);

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'CfId', label: 'Project ID' },
        { name: 'CfOpportunityDisplayName', label: 'Opportunity' },
        { name: 'CfLdvname', label: 'Office' },
        { name: 'CfName', label: 'Project Name' },
        { name: 'CfServiceName', label: 'Service' },
        { name: 'CfCcSassieId', label: 'Apollo Client ID' },
        { name: 'CfCcname', label: 'Client' },
        { name: 'CfLstname', label: 'Service Type' },
        { name: 'CfRcycode', label: 'Billing Currency' },
        { name: 'CfConame', label: 'Contact' },
        { name: 'CfReimbTypeText', label: 'Reimbursement Type' },
        { name: 'ShopCountInCycle', label: 'Shop Count In Cycle' },
        { name: 'CfProjectManagerName', label: 'Project Manager' },
        { name: 'CfStartDate', label: 'Start Date' },
        { name: 'CfEndDate', label: 'End Date' },
        { name: '-message-', label: 'Summary', className: 'text-left' },
        { name: 'CfComments', label: 'Project Summary', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
    {
      tabName: 'Client Fees',
      tabLabel: 'Client Fees',
      icon: 'fa-solid fa-coins',
      data: [{ name: ProjectItem.getClientFeeContent, label: 'Client Fees', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Surveys',
      tabLabel: 'Surveys',
      icon: 'fa-brands fa-grav fa-2x',
      data: [{ name: ProjectItem.getSurveyContent, label: 'Surveys', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Assignments',
      tabLabel: 'Assignments',
      icon: 'fa-solid fa-clipboard-list',
      data: [{ name: ProjectItem.getAssignmentsContent, label: 'Assignments', width: TabListTableCellWidthEnum.Table }],
    },
    {
      tabName: 'Comments',
      tabLabel: 'Comments',
      icon: 'fa-solid fa-comments',
      data: [
        { name: ProjectItem.getCommentsContent, label: 'Comments', width: TabListTableCellWidthEnum.TwoLines },
        { name: '-message-', label: 'The comments above are related to the primary user.' },
      ],
    },
    {
      tabName: 'Attachments',
      tabLabel: 'Attachments',
      icon: 'fa-solid fa-paperclip',
      data: [
        { name: ProjectItem.getAttachmentContent, label: 'Attachments', width: TabListTableCellWidthEnum.TwoLines },
      ],
    },
  ];

  // static getSurveyContent(item) {
  //     //if(!item.SassieId) return null;
  //     return <SurveyAdmin clientId={item.CfId} IsActive={item.IsActive} SassieId={item.SassieId} surveyDisplayType="Project" />;
  //   }

  static getCommentsContent(item) {
    return (
      <Comments
        entityTypeId={29}
        entityId={item.CfId}
      />
    );
  }

  static getAttachmentContent(item) {
    return (
      <AttachmentsComponent
        entityTypeId={29}
        entityId={item.CfId}
        isOverWindow={false}
      />
    );
  }

  static getClientFeeContent(item) {
    return (
      <ClientFeesComponent
        searchItem={item}
        serviceId={item.CfServiceId}
      />
    );
  }

  static getSurveyContent(item) {
    return (
      <ProjectSurveyAdmin
        searchItem={item}
        isOverWindow={false}
      />
    );
  }

  static getAssignmentsContent(item) {
    const tabs = [
      {
        label: 'Ready for Invoicing',
        id: 'finalized',
        icon: 'fa-solid fa-monument',
        component: (
          <FinalizedAssignmentsList
            Item={item}
            type='finalized'
          />
        ),
      },
      {
        label: 'Uninvoiceable',
        id: 'uninvoicable',
        icon: 'fa-solid fa-monument',
        component: (
          <UninvoiceableAssignmentsList
            CfId={item.CfId}
            type='uninvoiceable'
          />
        ),
      },
      {
        label: 'Excluded Pay Evaluators',
        id: 'excluded',
        icon: 'fa-solid fa-monument',
        component: (
          <ExcludedAssignmentsList
            CfId={item.CfId}
            type='excluded'
          />
        ),
      },
      {
        label: 'All Assignments',
        id: 'all',
        icon: 'fa-solid fa-monument',
        component: (
          <AllAssignmentsList
            CfId={item.CfId}
            type='all'
          />
        ),
      },
    ];
    return (
      <TabbedPage
        tabs={tabs}
        className='border rounded opacity70'
      />
    );
  }

  static Currency() {
    return '';
  }
  static CurrencySecondary() {
    return '';
  }
}

export default ProjectItem;
